export enum TritonStreamSidebandMetadataEvent {
  TRACK = 'track',
  SPEECH = 'speech',
  SWEEPER = 'sweeper',
  AD = 'ad',
  HLS = 'hls',
}

export enum AdType {
  END_BREAK = 'endbreak',
}

export interface TritonStreamSidebandMetadata {
  type: string;
  name: string;
  timestampMs: number;
  cuePointParameters: { [key: string]: string };
}

export interface AudioTrackMetadata {
  trackID?: string;
  trackDisplayTitle?: string;
  trackDisplayDurationMs?: number;
  trackAlbumName?: string;
  trackAlbumYear?: string;
  trackAlbumPublisher: string;
  trackArtistName?: string;
  trackCoverURL?: string;
}

export interface AudioSweeperMetadata {
  sweeperId?: string;
  sweeperType?: SweeperType;
}

export enum SweeperType {
  SWEEPER = 'SWEEPER',
  BUMPER = 'BUMPER',
  PROMO = 'PROMO',
  STATION_ID = 'STATION_ID',
  LINER = 'LINER',
  JINGLE = 'JINGLE',
}

export interface AdMetadata {
  adId?: string;
  adTitle?: string;
  adDurationMs?: number;
  vastInline?: string;
  vastRemote?: string;
}

export interface TrackMetadata {
  name: TritonStreamSidebandMetadataEvent;
  metadata: AudioTrackMetadata | AudioSweeperMetadata;
}
